// Floating action button for mobile / side-panel layouts. Rendered
// above the bottom MobileNav so it never overlaps it. Hidden at md+
// where the toolbar's "New" button takes over.

import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

interface FABProps {
  /** Navigate to a route. Mutually exclusive with onClick. */
  href?: string;
  /** Or call an action. */
  onClick?(): void;
  /** Accessible label. */
  label: string;
  /** Optional custom icon; defaults to a +. */
  icon?: ReactNode;
}

export function FAB({ href, onClick, label, icon }: FABProps) {
  const cls =
    'md:hidden fixed bottom-20 right-4 z-30 h-14 w-14 rounded-full shadow-lg surface border border-divider flex items-center justify-center text-strong hover:surface-hover transition active:scale-95';
  const content = icon ?? (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  );
  if (href) {
    return (
      <Link to={href} className={cls} aria-label={label} title={label}>
        {content}
      </Link>
    );
  }
  return (
    <button type="button" onClick={onClick} className={cls} aria-label={label} title={label}>
      {content}
    </button>
  );
}
